import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { campaignQaRunCacheKeys } from "./constants";
import type { DeleteCampaignQaRunProps, DeleteCampaignQaRunResult } from "./types";

/** DELETE handler for the "/:app_group_id/campaign_qa_runs/:campaign_id" endpoint. */
export const deleteCampaignQaRun = reactQueryMutationAdapter(
  campaignQaRunCacheKeys,
  (props: DeleteCampaignQaRunProps): Promise<DeleteCampaignQaRunResult> => {
    return fetch(`/${props.appGroupId}/campaign_qa_runs/${props.campaignId}`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
